import {
  UNLOCK_ACCOUNT_ADMIN_USER,
  UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS,
  UNLOCK_ACCOUNT_ADMIN_USER_ERROR,
  UNLOCK_TOKEN_ADMIN_USER,
  UNLOCK_TOKEN_ADMIN_USER_SUCCESS,
  UNLOCK_TOKEN_ADMIN_USER_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  unlock_admin_account: null,
}

const UnlockAdminUser = (state = initialState, action) => {
  switch (action.type) {
    case UNLOCK_ACCOUNT_ADMIN_USER:
      state = {
        ...state,
        loading: true,
        error: false,
      }
      break
    case UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        unlock_admin_account: action.payload,
        error: false,
      }
      break
    case UNLOCK_ACCOUNT_ADMIN_USER_ERROR:
      state = {
        ...state,
        unlock_admin_account: null,
        loading: false,
        error: action.payload,
      }
      break
    case UNLOCK_TOKEN_ADMIN_USER:
      state = {
        ...state,
        loading: true,
        error: false,
      }
      break
    case UNLOCK_TOKEN_ADMIN_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        unlock_admin_account: action.payload,
        error: false,
      }
      break
    case UNLOCK_TOKEN_ADMIN_USER_ERROR:
      state = {
        ...state,
        unlock_admin_account: null,
        loading: false,
        error: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default UnlockAdminUser;
